import AccountGuestDataTable from '../../../features/account-management/account-guest/AccountGuestDataTable'
import AccountGuestFilterHeader from '../../../features/account-management/account-guest/AccountGuestFilterHeader'

export default function GuestAccountListPage() {
  return (
    <div className="flex flex-col">
      <AccountGuestFilterHeader />
      <AccountGuestDataTable />
    </div>
  )
}
